import { Container, CircularProgress, Tabs, Tab } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import { capturePHEvents } from '../../../analytics/posthog.analytics';
import { sortArrayInAscending } from '../../../helper/commonHelper';
import Page from '../../../components/Page';
import { getChatMessage } from '../../../firebase/actions/firebaseGet';
import { studentClassTopBarOptions } from '../../../utils/constants';
import StudentOverview from './ClassDetails/Student.Overview';
import StudentResources from './ClassDetails/Student.Resources';
import StudentTest from './ClassDetails/Student.Test';
import StudentAssignment from './ClassDetails/Student.Assignment';
import { fetchClassById } from '../../../service/class.service';
import NewChat from '../../Chat/NewChat';
import { PH_STUDENT_CLASS_DETAILS_TAB_CHANGE } from '../../../utils/posthog.eventNames';
import Header from '../../../components/Header';
import { captureGAEvents } from '../../../analytics/google.analytics';
import { GAEvents } from '../../../analytics/events.constants';

const useStyles = makeStyles({
  headerAndButtonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  contentContainer: {
    marginTop: 20
  }
});

export default function StudentClassDetails() {
  const classes = useStyles();
  const location = useParams();
  const navigate = useNavigate();
  const selectedClass = useSelector((state) => state.classes.selectedClass);
  const [isClassLoading, setIsClassLoading] = useState(true);
  const [classData, setClassData] = useState(selectedClass);
  const [isChatLoading, setIsChatLoading] = useState(true);
  // const [classData, setClassData] = useState({});
  const [currentTab, setCurrentTab] = useState(0);
  const [chatMessages, setMessages] = useState([]);
  const classId = location.id;

  const getClassData = async () => {
    const res = await fetchClassById(classId);
    if (res) {
      setClassData(res.fetchedClass);
    }
    // else {
    //   navigate('/dashboard/classes');
    // }
    setIsClassLoading(false);
  };

  const handleChange = (event, newValue) => {
    capturePHEvents(PH_STUDENT_CLASS_DETAILS_TAB_CHANGE, {
      classId: classData.id,
      className: classData.name,
      selectedTab: event.target.innerText
    });
    setCurrentTab(newValue);
  };

  const getMessages = () => {
    getChatMessage(classId)
      .then((r) => {
        const message = [];
        r.forEach((d) => {
          message.push({ ...d.data(), firebaseId: d.id });
        });
        setMessages(sortArrayInAscending(message, 'createdAt'));
        setIsChatLoading(false);
      })
      .catch(() => {
        setMessages({
          error: true
        });
        setIsChatLoading(false);
      });
  };

  useEffect(() => {
    getClassData();
    getMessages();
    captureGAEvents(GAEvents.classesScreen, {
      screen: 'student_class_detail'
    });
  }, []);

  return (
    <Page
      title="Class Details"
      style={{
        display: `${isClassLoading ? 'flex' : ''}`,
        width: `${isClassLoading ? '100%' : ''}`,
        height: `${isClassLoading ? '100%' : ''}`,
        justifyContent: `${isClassLoading ? 'center' : ''}`,
        alignItems: `${isClassLoading ? 'center' : ''}`
      }}
    >
      <Container>
        {isClassLoading ? (
          <CircularProgress />
        ) : (
          <>
            <div className={classes.headerAndButtonContainer}>
              <Header title={classData.name} onBack={() => navigate('/dashboard/classes')} />
              {/* <Typography variant="h4" sx={{ mb: 5 }}>
                {classData.name}
              </Typography> */}
            </div>
            <Tabs
              value={currentTab}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons={false}
              aria-label="scrollable prevent tabs example"
            >
              {studentClassTopBarOptions.map((t, i) => (
                <Tab label={t.title} key={i} />
              ))}
            </Tabs>
            {currentTab === 0 && <StudentOverview classDetails={classData} />}
            {currentTab === 1 && <StudentResources classId={classId} />}
            {currentTab === 2 && <StudentTest />}
            {currentTab === 3 && (
              <NewChat
                isChatLoading={isChatLoading}
                chatMessage={chatMessages}
                classId={classId}
                classDetails={classData}
              />
            )}
            {currentTab === 4 && <StudentAssignment />}
          </>
        )}
      </Container>
    </Page>
  );
}
